import { ListInput } from "framework7-react";
import { NOTE_MAX_LENGTH } from "../utils/expense";

export const NOTE_INPUT_NAME = "note";

const NoteInput = ({ value, onChange }) => (
  <ListInput
    className="note-input"
    name={NOTE_INPUT_NAME}
    label="Notiz"
    type="textarea"
    outline
    resizable
    placeholder="Optional"
    maxlength={NOTE_MAX_LENGTH}
    autocapitalize="sentences"
    value={value}
    onChange={(event) => onChange(event.target.value)}
  />
);

// F7's <List> only renders children named f7-list-input* inside its <ul>.
NoteInput.displayName = "f7-list-input-note";

export default NoteInput;
